export enum UserTypes {
  None = 0,
  InsuranceAgency = 1,
  Agent = 2,
  TruckingCompany = 3,
  SuperUser = 4,
  ViewUser = 5,
}
